import React from 'react';
import PropTypes from 'prop-types';

import { ACTION_CANCEL_MOD } from './translations';

import styles from './ActionCancelMod.module.css';

export default class ActionCancelMod extends React.PureComponent {
    static propTypes = {
        onClick: PropTypes.func,
    }

    render() {
        return (
            <div className={styles.base} onClick={this.props.onClick}>
                {ACTION_CANCEL_MOD}
            </div>
        )
    }
}
